import React, {Fragment} from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Content from '../components/Sponring/Content'
import Hero from '../components/Sponring/Hero'



class AboutUs extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        return(
            <Fragment>
                <Header logoColor="#ffffff"  classStatic="error-head" dropDownColor="white" title="Albert"/>
                <Hero />
                <Content/>
                <Footer/>
            </Fragment>
        )
    }
}

export default AboutUs;